import { useEffect, useState } from "react";
import { db } from "../components/Auth/firebase";
import { getDoc, doc } from "firebase/firestore";

// Mock function to fetch user details
const fetchUserDetails = async (userId) => {
  const userDoc = await getDoc(doc(db, "users", userId));
  if (!userDoc.exists()) {
    return null;
  }
  return { id: userId, ...userDoc.data() };
};

// Mock function to check if a user is online
const isUserOnline = (userId) => {
  // This should ideally be replaced with real-time presence system
  return Math.random() < 0.5; // Randomly assign online status for demo purposes
};

export { fetchUserDetails, isUserOnline };
